<div class="header-wrapper">
  <!-- Left Content -->
  <div *ngIf="headerType === 'full' || headerType === 'title-only'"
       class="header-left-content"
       [ngClass]="displayBudgets ? '' : 'bigger-header-left-content'"
       [ngClass]="{'full-width': headerType !== 'full'}">
    <div class="header-text">{{headerText}}</div>
    <div class="subtitle" *ngIf="offeredBy">
      <div class="d-block">
        {{ 'FLEXIBLE_FIXED_BENEFITS.TEXT.OFFERED_BY' | translate }}
        <span class="semi-bold fs-12">{{ offeredBy }} </span>
      </div>
    </div>
    <div *ngIf="subheaderText" class="badge bg-warning taxes">{{subheaderText}}</div>
  </div>

  <!-- Right Content -->
  <div *ngIf="(headerType === 'full' || headerType === 'card-only') && showBudgetCard && userCompanyInfo?.hasFlexibleBenefits"
      class="card header-right-content"
      [ngClass]="displayBudgets ? '' : 'card'"
      [ngClass]="{'full-width': headerType !== 'full'}">
    <div class="d-flex card-body m-0 justify-content-center">
      <div [ngClass]="displayBudgets ? 'right-wrapper' : 'right-wrapper-no-border'">
        <available-budget *ngIf="displayBudgets"
                          [expander]="displayBudgets"
                          [hasTransportBudget]="userCompanyInfo?.hasTransportBudget"
                          [hasProfessionalDevelopmentBudget]="userCompanyInfo?.hasProfessionalDevelopmentBudget"
                          [hasCashbackBudget]="userCompanyInfo?.hasCashbackBudget"
                          [standardBudget]="userDashboardInfo?.totalAmount"
                          [transportBudget]="userDashboardInfo?.totalAmountTransport"
                          [professionalDevelopmentBudget]="userDashboardInfo?.totalAmountProfessionalDevelopment"
                          [cashbackBudget]="userDashboardInfo?.totalAmountCashback"
                          [cashbackPendingAmount]="pendingCashbackAmount"
                          [bigText]="bigText">
        </available-budget>

        <available-budget *ngIf="!displayBudgets"
                          [expander]="displayBudgets"
                          [bigText]="bigText"
                          [hasCashbackBudget]="userCompanyInfo?.hasCashbackBudget">
        </available-budget>

        <div class="horizontal-divider"></div>
        <div class="space-between fs-12" *ngIf="userCompanyInfo.pricingPlan === PricingPlan.FLEX">
          <div class="icon-text-container">
            <i [data-feather]="'lock'"></i>
            <div class="font-semibold">
              {{ 'DASHBOARD.USER_INFO.MONTHLY_COSTS' | translate }}
            </div>
          </div>
          <div class="font-bold">
            {{
              userDashboardInfo?.reservedAmount
                ? userDashboardInfo?.reservedAmount
                : 0
            }}
            {{ 'DASHBOARD.UNIT' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
